import Button from "../../components/Button";
import { TrackingUtil } from "../../utils/tracking";import { DataType, DataListType, IWidget, ACTION_VARIANT } from "../../types";
import { DOM } from "../../utils/domActions";
class VerticalItemList implements IWidget {
    container: HTMLElement | null = document.querySelector(
        "#trustshop-embed-vertical-item-list--container"
    );
    listData: DataListType | null = null;
    items: DataType[] = [];
    campaignId: string | null = null;
    
    render(): HTMLElement {
        if (!this.container) {
            this.container = DOM.createElement("div", {
                id: "trustshop-embed-vertical-item-list--container",
                className:
                    "trustshop-embed-vertical-item-list--container trustshop-embed--card",
            });
            document.body.appendChild(this.container);
        }

        const listWrap = DOM.createElement("div", {
            className: "trustshop-embed-vertical-item-list--wrap",
        });

        if (this.listData?.title || this.listData?.subtitle) {
            const header = DOM.createElement("div", {
                className: "trustshop-embed-vertical-item-list--header",
            });
            // Add title if present
            if (this.listData?.title) {
                const title = DOM.createElement("h2", {
                    className: "trustshop-embed-vertical-item-list--title",
                    textContent: this.listData.title,
                });
                header.appendChild(title);
            }

            // Add subtitle if present
            if (this.listData?.subtitle) {
                const subtitle = DOM.createElement("p", {
                    className: "trustshop-embed-vertical-item-list--subtitle",
                    textContent: this.listData.subtitle,
                });
                header.appendChild(subtitle);
            }

            listWrap.appendChild(header);
        }

        // Create items container
        const itemsContainer = DOM.createElement("div", {
            className: "trustshop-embed-vertical-item-list--items",
        });

        this.items.forEach((data) => {
            const item = this.renderItem(data);
            itemsContainer.appendChild(item);
        });

        if (this.listData?.view_all) {
            const viewAll = Button.create({
                label: this.listData.view_all.label,
                url: this.listData.view_all.url,
                variant: ACTION_VARIANT.PLAIN,
                className: "trustshop-embed-vertical-item-list--view-all",
            });
            itemsContainer.appendChild(viewAll);
        }

        listWrap.appendChild(itemsContainer);

        this.container.appendChild(listWrap);

        return this.container;
    }

    renderItem(data: DataType): HTMLElement {
        const item = DOM.createElement("div", {
            className: "trustshop-embed-vertical-item-list--item",
        });

        if (data.img_url) {
            const itemImage = DOM.createElement("div", {
                className: "trustshop-embed-vertical-item-list--item-image",
                innerHTML: `<img src="${data.img_url}" alt="${
                    data.title || "Item"
                }" />`,
            });
            item.appendChild(itemImage);
        }

        const itemContent = DOM.createElement("div", {
            className: "trustshop-embed-vertical-item-list--item-content",
        });
        // Item title
        if (data.title) {
            const itemTitle = DOM.createElement("h3", {
                className: "trustshop-embed-vertical-item-list--item-title",
            });
            itemTitle.textContent = data.title;
            itemContent.appendChild(itemTitle);
        }
        // Item description
        if (data.description) {
            const itemDescription = DOM.createElement("p", {
                className:
                    "trustshop-embed-vertical-item-list--item-description",
            });
            itemDescription.textContent = data.description;
            itemContent.appendChild(itemDescription);
        }
        item.appendChild(itemContent);

        if (
            data.secondary_actions &&
            Array.isArray(data.secondary_actions) &&
            data.secondary_actions.length > 0
        ) {
            const actionBtnWrap = DOM.createElement("div", {
                className: "trustshop-embed-vertical-item-list--item-actions",
            });
            data.secondary_actions.forEach((element) => {
                const actionBtn = Button.create({
                    ...element,
                    className: "trustshop-embed-vertical-item--action",
                });
                actionBtnWrap.appendChild(actionBtn);
            });
            item.appendChild(actionBtnWrap);
        }
        return item;
    }

    show(): void {
        throw new Error("Method not implemented.");
    }
    hide(): void {
        throw new Error("Method not implemented.");
    }
    toggle(): void {
        throw new Error("Method not implemented.");
    }
    destroy(): void {
        throw new Error("Method not implemented.");
    }
    isVisible(): boolean {
        throw new Error("Method not implemented.");
    }
    updateData(data: DataListType | DataType | DataType[]): void {
        // Check if it's a DataListType with title, subtitle, and data array
        if (data && "data" in data && Array.isArray(data.data)) {
            // Store the full DataListType object
            this.listData = data as DataListType;
            this.items = data.data.filter(Boolean) as DataType[];
        } else if (Array.isArray(data)) {
            // Direct array of items
            this.items = data;
            this.listData = null;
        } else {
            // Single item, wrap in array
            this.items = [data as DataType];
            this.listData = null;
        }
    }
}

const VerticalItemListInstance = new VerticalItemList();

export default VerticalItemListInstance;
